<mat-toolbar   class="headToolbar lupin-green-bg-color ">
  <img  class="image" src="assets/icons/Lupin_logo.jpg">
  <a class="title" >{{ title }}</a>
  <button mat-button  [matMenuTriggerFor]="menu"  class="menu-button" (click)="toggleListVisibility()"  *ngIf="isScreenSizeSmall">Menu</button>
  <mat-menu #menu="matMenu">
    <!-- <button mat-menu-item *ngIf="loginDisplay && scsAppDisplay" href="https://uat-scs.lupin.com/lupinSCSAzure/" >SCS Portal</button> -->
    <button mat-menu-item  *ngIf="!loginDisplay" (click)="login()">Login</button>
    <button mat-menu-item *ngIf="loginDisplay" (click)="logout()">Logout</button>
  </mat-menu>
  <div class="toolbar-spacer"></div>
  <nav class="alink"  *ngIf="!isScreenSizeSmall" [class.show-list]="isListVisible">
  <!-- <a mat-button *ngIf="loginDisplay && scsAppDisplay" href="https://uat-scs.lupin.com/lupinSCSAzure/"  >SCS Portal</a> -->
  <button mat-raised-button *ngIf="!loginDisplay" (click)="login()">Login</button>
  <button mat-raised-button *ngIf="loginDisplay" (click)="logout()">Logout</button>
  </nav>
</mat-toolbar>
<!-- <div class="container"> 
</div> -->
<div style="height: 100%;">
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div>